import ConversionTracker from 'components/analytics/conversions/conversion-tracker';

window.conversionTracker = new ConversionTracker();
window.conversionTracker.init();
